import { render, staticRenderFns } from "./Gestiones.vue?vue&type=template&id=0eb2e16a&scoped=true"
import script from "./Gestiones.vue?vue&type=script&lang=js"
export * from "./Gestiones.vue?vue&type=script&lang=js"
import style0 from "./Gestiones.vue?vue&type=style&index=0&id=0eb2e16a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb2e16a",
  null
  
)

export default component.exports